<template>
  <div class="devdocument">
    <div class="body">
      <el-container>
        <el-aside>
          <div class="dev_title">
            <span>
              全部文档
            </span>
          </div>
            <el-menu
             default-active="introduce"
              class="el-menu-vertical-demo"
              @select="handleSelect">
              <el-menu-item index="introduce">平台简介</el-menu-item>
              <el-submenu index="argument">
                <template slot="title">
                  <span>政策规范</span>
                </template>
                  <el-menu-item index="agreement">开发者协议</el-menu-item>
              </el-submenu>
              <el-submenu index="api">
                <template slot="title">
                  <span>API文档</span>
                </template>
                <el-submenu index="stageList">
                  <template slot="title" ><span>目录接口</span></template>
                  <el-menu-item index="stageList">学段列表接口</el-menu-item>
                  <el-menu-item index="subjectList">科目列表接口</el-menu-item>
                  <el-menu-item index="versionList">教材版本列表接口</el-menu-item>
                  <el-menu-item index="volumeList">教材册别列表接口</el-menu-item>
                  <el-menu-item index="sectionList">教材章节列表接口</el-menu-item>
                  <el-menu-item index="knowledgeList">知识点列表接口</el-menu-item>
                  <el-menu-item index="examTypeList">试卷类型列表接口</el-menu-item>
                  <el-menu-item index="questionTypeList">试题类型列表接口</el-menu-item>
                  <el-menu-item index="questionDifficult">试卷难度列表接口</el-menu-item>
                  <el-menu-item index="provinceList">省份列表接口</el-menu-item>
                  <el-menu-item index="gradeList">年级列表接口</el-menu-item>
                  <el-menu-item index="docTypeList">文档类型接口</el-menu-item>
                  <el-menu-item index="docColumnList">文档栏目接口</el-menu-item>
                </el-submenu>
                <el-submenu index="exam">
                  <template slot="title"><span>试题接口</span></template>
                  <el-menu-item index="booknodeExam">通过单元章节获取普通试题接口</el-menu-item>
                  <el-menu-item index="knowledgeExam">通过知识点获取普通试题接口</el-menu-item>
                  <el-menu-item index="singleExam">获取普通单试题答案或解析接口</el-menu-item>
                  <el-menu-item index="getExamIds">试题id集合</el-menu-item>
                  <el-menu-item index="getExamLists">试题列表集合</el-menu-item>
                  <el-menu-item index="getExamListsByChapter">根据章节获取精品试题列表</el-menu-item>
                  <el-menu-item index="getExamListsByKnow">根据知识点获取精品试题列表</el-menu-item>
                  <el-menu-item index="getExamListsAnaysis">获取精品试题答案解析</el-menu-item>
                  <el-menu-item index="getExamListsByUnitChapter">通过单元章节获取所有试题接口</el-menu-item>
                  <el-menu-item index="getAllExamListsByKnow">通过知识点获取所有试题接口</el-menu-item>
                  <el-menu-item index="getExamAnswerAndAnaysis">获取试题答案解析</el-menu-item>
                </el-submenu>
                <el-submenu index="paper">
                  <template slot="title"><span>试卷接口</span></template>
                  <el-menu-item index="getPaperList">获取试卷列表</el-menu-item>
                  <el-menu-item index="getPaperDetailByPaperId">通过试卷id获取试卷详情</el-menu-item>
                </el-submenu>
                <el-submenu index="document">
                  <template slot="title"><span>文档接口</span></template>
                  <el-menu-item index="getDocumentList">获取普通文档列表</el-menu-item>
                  <el-menu-item index="getDocumentDetail">获取文档详情</el-menu-item>
                  <el-menu-item index="getDocumentDownloadUrl">获取普通文档资源下载地址</el-menu-item>
                  <el-menu-item index="getGoodDocumentList">获取精品文档列表</el-menu-item>
                  <el-menu-item index="getGoodDocumentDownloadUrl">获取精品文档资源下载地址</el-menu-item>
                  <el-menu-item index="getAllDocList">获取所有文档列表</el-menu-item>
                  <el-menu-item index="getDocDownloadUrl">获取文档资源下载地址</el-menu-item>
                </el-submenu>
                <el-submenu index="famousSchoolSwiper">
                  <template slot="title" ><span>名校接口</span></template>
                  <el-menu-item index="famousSchoolSwiper">获取名校轮播资源文档列表</el-menu-item>
                  <el-menu-item index="famousSchoolInfo">查询名校信息</el-menu-item>
                  <el-menu-item index="famousSchool">获取名校资源文档列表</el-menu-item>
                  <el-menu-item index="famousSchoolDoc">获取名校文档资源下载地址</el-menu-item>
                </el-submenu>
                <el-submenu index="microVideo">
                  <template slot="title" ><span>微课接口</span></template>
                  <el-menu-item index="microVideo">获取微课视频列表</el-menu-item>
                  <el-menu-item index="microPlayCode">获取微课播放授权码</el-menu-item>
                  <el-menu-item index="microSubject">根据通用学段获取微课学科列表</el-menu-item>
                  <el-menu-item index="microKnow">根据微课学科获取微课知识点</el-menu-item>
                </el-submenu>
              </el-submenu>
              <el-menu-item index="formulaEX">文档公式显示示例</el-menu-item>
              <el-menu-item index="errorCode">错误码</el-menu-item>
              <el-menu-item index="autograph">签名算法</el-menu-item>
            </el-menu>
        </el-aside>
        <el-main>
          <el-container>
            <el-main class="content-wrapper">
              <div class="devdocumentIntroduce" v-if="mainHtml.showContent" v-html="mainHtml.content">
              </div>
              <el-breadcrumb v-if="mainHtml.showBreadcrumnb" separator=">" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(b, index) in mainHtml.breadcrumnbList" :key="index">
                  <span v-if="(index+1) !== mainHtml.breadcrumnbList.length">{{b}}</span>
                  <b v-else>{{b}}</b>
                </el-breadcrumb-item>
              </el-breadcrumb>
              <!-- <h1 v-if="mainHtml.showInterfaceInfo">{{mainHtml.title}}</h1> -->
              <h1 class="subtitle" v-if="mainHtml.showInterfaceInfo">接口详情</h1>
              <el-table
                v-if="mainHtml.showInterfaceInfo"
                :data="mainHtml.interfaceInfoTable.tableData"
                header-row-class-name="my-header-row-class"
                border
                style="width:100%">
                <el-table-column
                  v-for="(item, index) in mainHtml.interfaceInfoTable.tableHead"
                  :key="index"
                  :prop="item.prop"
                  :width="item.width"
                  :min-width="item.minWidth"
                  :align="item.align"
                  :label="item.label"
                >
                </el-table-column>
              </el-table>

              <h1 class="f16" v-if="mainHtml.showRequestHeadParams"><div class="subtitle">头部请求参数</div></h1>
              <el-table
                v-if="mainHtml.showRequestHeadParams"
                :data="mainHtml.requestHeadParamsTable.tableData"
                header-row-class-name="my-header-row-class"
                border
                style="width: 100%">
                <el-table-column
                  v-for="(item, index) in mainHtml.requestHeadParamsTable.tableHead"
                  :key="index"
                  :prop="item.prop"
                  :width="item.width"
                  :min-width="item.minWidth"
                  :align="item.align"
                  :label="item.label"
                >
                </el-table-column>
              </el-table>

              <h1 class="f16" v-if="mainHtml.showYWRequestParamsTable"><div class="subtitle">业务请求参数</div></h1>
              <el-table
                v-if="mainHtml.showYWRequestParamsTable"
                :data="mainHtml.yWRequestParamsTable.tableData"
                header-row-class-name="my-header-row-class"
                border
                style="width: 100%">
                <el-table-column
                  v-for="(item, index) in mainHtml.yWRequestParamsTable.tableHead"
                  :key="index"
                  :prop="item.prop"
                  :width="item.width"
                  :min-width="item.minWidth"
                  :align="item.align"
                  :label="item.label"
                >
                </el-table-column>
              </el-table>
              <div style="color: red" v-if="mainHtml.YWRequestParamsErrorInfo">{{mainHtml.YWRequestParamsErrorInfo}}</div>
              <h1 class="f16" v-if="mainHtml.showResponseTable"><div class="subtitle">响应参数</div></h1>
              <el-table
                v-if="mainHtml.showResponseTable"
                :data="mainHtml.responseTable.tableData"
                header-row-class-name="my-header-row-class"
                border
                style="width: 100%">
                <el-table-column
                  v-for="(item, index) in mainHtml.responseTable.tableHead"
                  :key="index"
                  :prop="item.prop"
                  :width="item.width"
                  :min-width="item.minWidth"
                  :align="item.align"
                  :label="item.label"
                >
                </el-table-column>
              </el-table>
              <h1 class="f16" v-if="mainHtml.showKeyIntroduct"><div class="subtitle">字段解释</div></h1>
              <el-table
                v-if="mainHtml.showKeyIntroduct"
                :data="mainHtml.keyIntroductTable.tableData"
                header-row-class-name="my-header-row-class"
                border
                style="width: 100%">
                <el-table-column
                  v-for="(item, index) in mainHtml.keyIntroductTable.tableHead"
                  :key="index"
                  :prop="item.prop"
                  :width="item.width"
                  :min-width="item.minWidth"
                  :align="item.align"
                  :label="item.label"
                >
                </el-table-column>
              </el-table>
              <div style="color: red" v-if="mainHtml.keyIntroductErrorInfo">{{mainHtml.keyIntroductErrorInfo}}</div>
              <h1 class="f16" v-if="mainHtml.showResponseCode"><div class="subtitle">响应示例</div></h1>
              <div class="data" v-if="mainHtml.showResponseCode">
                <pre>
                  {{mainHtml.responseCode}}
                </pre>
              </div>
              <div class="constTable" v-if="mainHtml.showMathMlExample">
                <h1>文档公式显示示例</h1>
                <div style="margin: 13px 35px 20px 35px;">在html文档中引入第三方库MathJax.js以支持数学公式显示，具体示例如下：</div>
                <div class="code">
                  <div style="float: right;position:relative;right: 35px; z-index: 10;">
                      <el-button type="text" @click="copyCode">复制</el-button>
                  </div>
                  <codemirror v-model="code" :options="cmOption"></codemirror>
                </div>
                <pre id="content">
                  {{ content }}
                </pre>
              </div>
              <div class="constTable" v-if="mainHtml.showErrorCode">
                <h1>错误码</h1>
              </div>
              <el-table
                v-if="mainHtml.showErrorCode"
                :data="mainHtml.errorCodeTable.tableData"
                header-row-class-name="my-header-row-class"
                border
                style="width: 100%">
                <el-table-column
                  v-for="(item, index) in mainHtml.errorCodeTable.tableHead"
                  :key="index"
                  :prop="item.prop"
                  :width="item.width"
                  :min-width="item.minWidth"
                  :align="item.align"
                  :label="item.label"
                >
                </el-table-column>
              </el-table>
              <div class="constTable" v-if="mainHtml.showAutographContent">
                <h1>签名算法步骤</h1>
              </div>
              <div class="devdocumentIntroduce showAutographContent" v-if="mainHtml.showAutographContent" v-html="mainHtml.content1"></div>
              <img v-if="mainHtml.showTableImg" style="display: block;" src="../../../assets/images/word/table1.png" alt="">
              <div class="devdocumentIntroduce showAutographContent" v-if="mainHtml.showAutographContent" v-html="mainHtml.content2"></div>
              <div class="devdocumentIntroduce showAutographContent" v-if="mainHtml.showAutographContent" v-html="mainHtml.content3"></div>
              <div class="devdocumentIntroduce showAutographContent" v-if="mainHtml.showAutographContent" v-html="mainHtml.content4"></div>
              <div class="devdocumentIntroduce showAutographContent" v-if="mainHtml.showAutographContent" v-html="mainHtml.content5"></div>
            </el-main>
          </el-container>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script type="text/babel">
import {data} from './data'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/go/go.js'
import 'codemirror/mode/php/php.js'
import 'codemirror/mode/vb/vb.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/theme/darcula.css'
import 'codemirror/addon/selection/active-line.js'
import {FORMULAHTML_CODE} from '@/utils/code'

export default {
  components: {
    codemirror
  },
  data: function () {
    return {
      mainHtml: data.introduce,
      keyName: '',
      codes: [FORMULAHTML_CODE],
      code: FORMULAHTML_CODE,
      content: FORMULAHTML_CODE,
      models: ['text/x-vb'],
      cmOption: {
        tabSize: 4,
        readOnly: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'text/x-go',
        lineWrapping: true,
        theme: 'darcula'
      }
    }
  },
  name: 'devdocument',
  methods: {
    handleSelect (key) {
      this.keyName = key
      this.mainHtml = data[key]
      window.scrollTo(0, 0)
    },
    copyCode () {
      const range = document.createRange()
      range.selectNode(document.getElementById('content'))
      const selection = window.getSelection()
      if (selection.rangeCount > 0) selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
    }
  }
}
</script>
<style scoped>

</style>
<style>
  .devdocument{
    background: #F7F7F7;
    overflow: hidden;
  }
  .devdocument .e-table .cell {
    text-overflow: inherit;
  }
  .devdocument .dev_title{
    padding: 0px 20px;
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: 600;
    color: #333333;
    line-height: 46px;
    margin-bottom: 10px;
    border-bottom:1px solid rgba(223,223,223,1);
  }
  .devdocument .body{
    width: 1200px;
    overflow-y: hidden;
    margin: 30px auto;
  }

  .devdocument .el-container{
    height: 100%;
    min-height: 600px;
  }

  .devdocument .el-aside{
    background: #ffffff;
    margin-right: 20px;
    min-height: 600px;
  }

  .devdocument  .el-menu-item,
  .dev_title .el-submenu__title,
  .devdocument .el-submenu__title span{
    color:#333333;
    font-weight:600;
    font-size: 13px;
  }
  .devdocument .el-submenu__title span{
    padding-left: 23px;
  }
  .devdocument  .el-menu-item.is-active{
    border-left: 3px solid #108EE9;
    color: #108EE9;
    background-color: #ECF5FF;
  }
  .devdocument .el-collapse-item{
    margin-left:20px;
  }
  .devdocument .el-menu-item{
    border-left: 3px solid white;
    padding-left: 40px !important;
    line-height: 40px;
    height: 40px;
  }
  .devdocument .el-menu-item,.devdocument  .el-submenu__title {
    line-height: 40px;
    height: 40px;
  }
  .devdocument .el-submenu {
    line-height: 40px;
  }
  .devdocument .el-submenu .el-menu-item{
    padding-left: 80px !important;
  }
  .devdocument .el-menu-item:hover{
    border-left: 3px solid #ECF5FF;
  }
  .devdocument .el-menu{
    border-right:none;
  }

  .devdocument .content-wrapper{
    font-family: "Microsoft Yahei";
    font-size: 14px;
    color: #3a3a3a;
    width:948px;
    margin: 20px;
  }

  .devdocument .subtitle{
    font-weight: 600;
    font-size: 14px;
  }

  .devdocument .content-wrapper .data pre{
    display: block;
    padding: 9.5px;
    margin: 0 0 10px;
    font-size: 12px;
    font-family:ArialMT;
    font-weight: 400;
    overflow-y: auto;
    line-height: 1.42857143;
    word-break: break-all;
    word-wrap: break-word;
    color: #666666;
    background-color: #FDFDFD;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .devdocument .content-wrapper h1{
    margin-top: 30px;
    margin-bottom: 10px;
  }

  .devdocument .my-header-row-class{
    color: #333333;
    font-weight: 600;
  }
  .devdocumentIntroduce h1{
    font-weight: 600;
    height: 30px;
    line-height:30px;
    font-size: 18px;
    padding-bottom: 40px;
    margin: 0 0 10px;
    border-bottom: 1px solid #f0f0f0;
    padding-left: 30px;
  }
  .devdocumentIntroduce p{
    line-height: 30px;
    margin-bottom: 5px;
    text-indent: 2em;
    padding:0 30px;
  }
  .constTable h1{
    margin-top: 33px;
    margin-bottom: 23px;
    font-size:18px;
    font-family:MicrosoftYaHei;
    font-weight:600;
    color:rgba(51,51,51,1);
  }
  .constTable #content {
    position: absolute;
    top: 0;
    opacity: 0;
  }

  .constTable .code{
    margin: 13px 35px 35px 35px;
    border-radius:4px;
  }

  .constTable .CodeMirror.cm-s-darcula{
    height: 900px;
    border: 1px solid #EBEBEB;
    background-color: #F7F7F7;
    color:#666666;
  }

  .constTable .cm-s-darcula.CodeMirror{
    background-color: #F7F7F7;
  }
  .constTable  .CodeMirror-linenumber{
    color:#666666;
  }
  .constTable  .CodeMirror-linenumber.CodeMirror-gutter-elt,
  .constTable .CodeMirror-gutter.CodeMirror-linenumbers{
    background-color: #F7F7F7;
  }
  .constTable .CodeMirror-gutters{
    border-color: #F7F7F7 ;
    margin-right: 18px;
    border-right: 1px solid #F7F7F7!important;
  }
  .constTable .cm-s-darcula span.cm-variable {
    color:#666666!important;
  }
  .constTable .CodeMirror-activeline{
    background-color: #ffffff;
  }
  .constTable .CodeMirror-activeline .CodeMirror-line{
    /*background-color: #ffffff;*/
    background-color: #F7F7F7;
  }
  .constTable .el-button--text{
    color: #108EE9;
  }
  .constTable .el-date-table,.constTable  .el-table th {
    padding: 6px 0;
  }
  .content-wrapper th {
    background-color: #e0e0e0;
  }
  .constTable th, .constTable td {
    font-size: 12px;
  }
  .devdocument .el-main {
    background-color: #fff;
  }
  .devdocument .el-table td, .el-table th {
    padding: 6px 0;
    font-size: 12px;
  }
  .devdocument .el-table th>.cell {
    font-weight: 600;
    color: #424242;
  }
  .showAutographContent p {
    text-indent: inherit;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/dev-document/index.vue